import ms from 'ms';
import typeCheck from 'common/util/typeCheck';
import isNull from 'common/util/isNull';
import safeLocalStorage from 'client/lib/safeLocalStorage';

import sendDataToMobileApp, {
  SR_MOBILE_APP_ACTION_TYPE_GET_CURRENT_LOCATION,
} from 'client/helpers/sendDataToMobileApp';

import { SR_WEB_APP_ACTION_TYPE_CURRENT_LOCATION } from 'client/components/SrMobileAppEventListener';

const webGeolocationPermissionKey = 'webGeolocationPermission';

export function getWebGeolocationPermission() {
  const webGeolocationPermission = safeLocalStorage.getItem(webGeolocationPermissionKey);
  return isNull(webGeolocationPermission)
    ? webGeolocationPermission
    : webGeolocationPermission === 'true';
}

export function setWebGeolocationPermission(webGeolocationPermission) {
  typeCheck('webGeolocationPermission::Boolean', webGeolocationPermission);
  return safeLocalStorage.setItem(webGeolocationPermissionKey, webGeolocationPermission);
}

export function getCurrentWebGeolocation(options = {}) {
  const { enableHighAccuracy, timeout, maximumAge } = options;

  return new Promise((resolve, reject) => {
    global.navigator.geolocation.getCurrentPosition(
      (position) => resolve(position),
      (error) => reject(error),
      { enableHighAccuracy, timeout, maximumAge }
    );
  });
}

export function getCurrentMobileGeolocation() {
  return new Promise((resolve, reject) => {

    const timeoutId = setTimeout(() => {
      global.document.removeEventListener('sunroomMobileAppEvent', onSunroomMobileAppEvent);
      reject(new Error('Location request timed out.'));
    }, ms('1m'));

    const onSunroomMobileAppEvent = (evt) => {
      const { actionType, data } = evt.detail;
      if (actionType === SR_WEB_APP_ACTION_TYPE_CURRENT_LOCATION) {
        global.document.removeEventListener('sunroomMobileAppEvent', onSunroomMobileAppEvent);
        clearTimeout(timeoutId);

        if (data.success) {
          resolve(data.position);
        }
        else {
          reject(new Error(data.errorMessage));
        }
      }
    };

    // Wait for event response from mobile app
    global.document.addEventListener('sunroomMobileAppEvent', onSunroomMobileAppEvent);

    // Send event to mobile app
    sendDataToMobileApp({
      actionType: SR_MOBILE_APP_ACTION_TYPE_GET_CURRENT_LOCATION,
    });
  });
}
